module.exports = __webpack_public_path__ + "static/media/OfAFeather.a78e9ebc.jpg";